<template>
	<div 
	class="form-group" 
	:class="formGroupClass">
		
		<form-label 
		v-if="label" 
		:class="labelClass"
		:for="id"
		v-html="$sanitize(label)" />
		
		<input-group 
		ref="search" 
		class="input-place"
		prepend-icon="geo-alt"
		:value="place"
		:class="autocomplete_open ? 'is-open' : ''" 
		v-bind="$attrs" 
		@focusout="autocomplete_open = false">

			<template #append>
				<div 
				v-if="value"
				class="input-group-text">
					<button 
					class="erase-btn"
					@click="erase">
						<i class="bi bi-x"></i>
					</button>
				</div>
			</template>

		</input-group>

		<form-errors v-bind="{errors}" />

	</div>
</template>

<script>

	import {Loader, LoaderOptions} from 'google-maps'

	export default {

		props: {

			id: {
				type: String,
				default() {
					return `input-place-${this._uid}`
				},
			},

			formGroupClass: {
				type: [String, Array],
				default: ''
			},

			labelClass: {
				type: String,
				default: ''
			},
			
			errors: {
  				type: String,
 				default: "",
  			},

			type: String,
			label: String,
			value: [String, Object, Array],
			sublabel: String,
		},

		data() {
			return {
				autocomplete_open: false
			};
		},

		computed: {

			place() {
				var value = this.value
				return _.isObject(value) ? value.address : value
			}

		},

		methods: {

			erase() {
				this.$emit('input', null)
			}

		},

		async mounted() {

			var input = this.$refs.search.$refs.input

			var options = this.type == 'city' ? {
				types: ['(cities)']
			} : null;

			setTimeout(() => {

				this.autocomplete = new google.maps.places.Autocomplete(
					input, options
				);
			
				this.autocomplete.addListener('place_changed', () => {

					var place = this.autocomplete.getPlace();
					this.autocomplete_open = false
					var address_details = {}
						

					// Format address components
					place.address_components.forEach(component => {

						var type = component.types[0]

						switch(type) {

							case 'route':
								type = 'street';
								break;

							case 'locality':
								type = 'city';
								break;

							case 'administrative_area_level_2':
								type = 'department';
								break;

							case 'administrative_area_level_1':
								type = 'region';
								break;

							case 'postal_code':
								type = 'zipcode';
								break;
						}

						address_details[type] = component.long_name
					})

					var output = {
						name: place.name,
						address: place.formatted_address,
						details: address_details,
						lat: place.geometry.location.lat(),
						lng: place.geometry.location.lng(),
						zoom: 14,
						place_id: place.place_id
					};

					this.$emit('input', place.name ? output : null)

				});

			}, 1000)

		}
	}
</script>